import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generic array-filter pipe.
 *
 * Usage:
 *   items | filterArray:['a', 'b']                     -> items included in ['a','b']
 *   items | filterArray:['a', 'b']:true                 -> items excluded from ['a','b']
 *   items | filterArray:allowed:false:'code'            -> filter objects by item.code
 */
@Pipe({
    name: 'filterArray',
    standalone: false
})
export class FilterArrayPipe implements PipeTransform {
    transform<T>(
        items: T[] | null | undefined,
        values: unknown[] | null | undefined,
        exclude: boolean = false,
        key?: keyof T
    ): T[] {
        if (!items?.length || !values?.length) {
            return exclude ? (items ?? []) : [];
        }

        return items.filter(item => {
            const comparisonValue = key ? item[key] : item;
            const isIncluded = values.includes(comparisonValue as unknown);
            return exclude ? !isIncluded : isIncluded;
        });
    }
}